const uiuxSteps = [
  {
    number: "01",
    title: "Analyse & Konzeption",
    description:
      "Wir starten mit umfassender Benutzerforschung, Wettbewerbsanalysen und der Erstellung detaillierter Personas sowie Customer Journeys. So legen wir eine fundierte Grundlage, um alle Anforderungen zu erfassen und ein zielgerichtetes, nutzerzentriertes Konzept zu entwickeln.",
  },
  {
    number: "02",
    title: "Wireframing, Prototyping & Interface Design",
    description:
      "Basierend auf dem Konzept erstellen wir zunächst Low-Fidelity-Wireframes, die die grundlegende Struktur und Navigation skizzieren. Anschließend entwickeln wir interaktive Prototypen, um den Nutzerfluss und die Funktionalität zu testen. Im finalen Interface Design berücksichtigen wir responsives Design und eine Mobile-First-Strategie, um auf allen Geräten ein konsistentes und ansprechendes Nutzererlebnis zu gewährleisten.",
  },
  {
    number: "03",
    title: "Usability-Tests & Optimierung",
    description:
      "In dieser Phase führen wir umfangreiche Usability-Tests mit realen Nutzern durch, um Feedback zu sammeln und eventuelle Schwachstellen zu identifizieren. Durch iterative Anpassungen und Optimierungen stellen wir sicher, dass das Design intuitiv, benutzerfreundlich und technisch ausgereift ist.",
  },
  {
    number: "04",
    title: "Handoff, Implementierung & Kontinuierliche Verbesserung",
    description:
      "Nach Freigabe des finalen Designs bereiten wir detaillierte Spezifikationen und Assets für die Entwickler vor, um eine reibungslose Umsetzung zu gewährleisten. Auch nach dem Launch begleiten wir Sie mit kontinuierlicher Analyse, regelmäßigen Updates und Optimierungen, um den langfristigen Erfolg Ihrer digitalen Produkte sicherzustellen.",
  },
];

export default uiuxSteps;
